export default __webpack_public_path__ + "static/media/angular.367d4f3d.png";